
<template lang="pug">
div
  .grid__tr(v-for="row of rows")
    .grid__row-header(:style="[style, row.style]") {{getText_(row)}}
</template>

<script>
export default {
  props: {
    grid: {type: Object, required: true},
    rows: {type: Array, required: true},
    getText: Function,
  },

  computed: {
    style() {
      return {
        width: this.grid.headerW + 'px',
        height: this.grid.cellH + 'px',
      }
    },

    getText_() {
      return this.getText || (cell => cell.text)
    },
  },
}
</script>
